import { CONFIG_CONTEXT } from '../../../enum/config-context.enum';
import { BaseInstallationComponent } from '../common/base-installation/base-installation.component';
import { BaseFundingComponent } from '../common/base-funding/base-funding.component';
import { BaseValidationComponent } from '../common/base-validation/base-validation.component';
import { TunnelStep } from '../model/tunnel-step-type';
import { Configurators2DComponent } from '../../configurators-2d/configurators-2d.component';
import { ConfigurationComponent } from '../../configuration/configuration.component';
import { KitchenConfigurationData } from '../../../stores/tunnel/model/configuration-data/kitchen-configuration-data';
import { MODAL } from '../../../services/modal.service';
import { KitchenComponent } from '../../kitchen/kitchen.component';
import { FidelityCardTypeEnum } from '../../../services/fidelity/fidelity';
import { TunnelDataState } from '../../../stores/tunnel/model/tunnel-data-state';
import { BaseComplementaryProductComponent } from '../common/base-complementary-product/base-complementary-product.component';
import { BomDataHelper } from '../../../services/helpers/bom-data-helper';

function isBomEmpty(stateValue: TunnelDataState): boolean {
  const configuration = stateValue.configurationData.get(CONFIG_CONTEXT.KITCHEN) as
    | KitchenConfigurationData
    | undefined;
  return BomDataHelper.isBomUnavailableForProductList(configuration?.bom);
}

export const KITCHEN_TUNNEL_STEPS: TunnelStep[] = [
  {
    component: KitchenComponent,
    context: CONFIG_CONTEXT.KITCHEN,
    title: 'Inspiration',
    modalToOpen: MODAL.WARNING_INSPIRATION,
  },
  {
    component: ConfigurationComponent,
    context: CONFIG_CONTEXT.KITCHEN,
    title: 'Conception',
  },
  {
    component: BaseComplementaryProductComponent,
    context: CONFIG_CONTEXT.KITCHEN,
    title: 'Produits complémentaires',
    canPrint: false,
    isDisabled: stateValue => {
      return isBomEmpty(stateValue);
    },
  },
  {
    component: Configurators2DComponent,
    context: CONFIG_CONTEXT.WORKBENCH,
    title: 'Plan de travail',
    isDisabled: stateValue => {
      return isBomEmpty(stateValue);
    },
    modalToOpen: MODAL.KITCHEN_TUNNEL_WORKBENCH_CHOICE,
  },
  {
    component: BaseInstallationComponent,
    context: CONFIG_CONTEXT.KITCHEN,
    title: 'Pose',
    canPrint: false,
    isDisabled: stateValue => {
      return isBomEmpty(stateValue);
    },
  },
  {
    component: BaseFundingComponent,
    context: CONFIG_CONTEXT.KITCHEN,
    title: 'Financement',
    canPrint: false,
    readonlyProductList: true,
    isDisabled: (stateValue, featureSettings) => {
      if (!featureSettings.financement) {
        return isBomEmpty(stateValue);
      }

      return (
        stateValue.currentPricing?.totalWithoutFunding === undefined ||
        (featureSettings.pose &&
          stateValue.currentInstallation?.withInstallation !== false &&
          stateValue.currentInstallation?.more2Years === undefined) ||
        isBomEmpty(stateValue)
      );
    },
  },
  {
    component: BaseValidationComponent,
    context: CONFIG_CONTEXT.KITCHEN,
    title: 'Validation',
    canPrint: true,
    readonlyProductList: true,
    modalToOpen: MODAL.FIDELITY_ADVERTISMENT,
    skipModalToOpen: (stateValue, featureSettings) => {
      return (
        !featureSettings.fidelity ||
        (stateValue.currentCustomer?.fidelity?.typeCard !== FidelityCardTypeEnum.AUCUNE &&
          stateValue.currentCustomer?.fidelity?.typeCard !== FidelityCardTypeEnum.AUCUNE0)
      );
    },
    isDisabled: (stateValue, featureSettings) => {
      return (
        (featureSettings.financement
          ? stateValue.currentPricing?.totalWithFunding === undefined || stateValue.currentFunding === undefined
          : stateValue.currentPricing?.totalWithoutFunding === undefined) ||
        (featureSettings.pose && stateValue.currentInstallation === undefined) ||
        stateValue.fidelityLoading ||
        (featureSettings.financement && stateValue.fundingLoading) ||
        isBomEmpty(stateValue)
      );
    },
  },
];
